import { memo } from 'react';

import { useMobileMediaQuery } from '@/shared/lib/hooks';
import { Loader } from '@/shared/ui/loader';

import cls from './page-loader.module.css';

/**
 * App page loader
 */
export const PageLoader = memo(() => {
    const isMobile = useMobileMediaQuery();

    return (
        <section className={cls.root}>
            <Loader
                isFullPage
                size={isMobile ? 'medium' : 'large'}
            />
        </section>
    );
});

PageLoader.displayName = 'PageLoader';
